import React from 'react';
import { Alert, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

/**
 * Shared banner for all QuickBooks-sourced finance screens.
 *
 * These screens are deliberately kept as a truthful mirror of QuickBooks —
 * they show what QB says, not what the native ledger computes. This banner
 * makes that provenance explicit so QB figures are never mistaken for the
 * platform's own accounting.
 */
export default function QuickBooksSourceBanner({ lastSync, variant }) {
  if (variant === 'settings') {
    return (
      <Alert severity="info" sx={{ mb: 2 }}>
        <strong>QuickBooks configuration.</strong> These mappings and rules feed the QuickBooks
        sync and the QB-view screens only; they do not affect the platform&apos;s native ledger.
      </Alert>
    );
  }
  return (
    <Alert severity="info" sx={{ mb: 2 }}>
      <strong>QuickBooks view.</strong> Figures on this screen mirror QuickBooks
      {lastSync ? ` as of the last sync (${lastSync})` : ' as of the last sync'} and can differ
      from the platform&apos;s native ledger. For natively computed figures use the{' '}
      <Link component={RouterLink} to="/finance/journal-reconciliation">Reconciliation Hub</Link>.
    </Alert>
  );
}
